import { render, staticRenderFns } from "./DouceNavbar.vue?vue&type=template&id=077b05f6&scoped=true&"
import script from "./DouceNavbar.vue?vue&type=script&lang=js&"
export * from "./DouceNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b05f6",
  null
  
)

export default component.exports